import { render } from "./RemoveIcon.vue?vue&type=template&id=154fe046&scoped=true"
import script from "./RemoveIcon.vue?vue&type=script&lang=js"
export * from "./RemoveIcon.vue?vue&type=script&lang=js"

import "./RemoveIcon.vue?vue&type=style&index=0&id=154fe046&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-154fe046"

export default script